import React from 'react';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { Box, Card, CardContent, Typography } from '@mui/material';

export type GreffeChoice = {
    id: number;
    greffes: string;
};

export type GreffeCardProps = GreffeChoice & {
    checked: boolean;
    onClick: (greffe: GreffeChoice) => void;
};

const GreffeCard: React.FunctionComponent<GreffeCardProps> = function (props) {
    const { id, greffes, checked, onClick } = props;
    const color = checked ? 'primary' : 'default';

    return (
        <Card
            key={id}
            variant="outlined"
            data-testid="greffe-choice"
            sx={{
                margin: 0,
                cursor: 'pointer',
                bgcolor: checked ? 'primary.50' : 'background.paper',
                border: checked ? 2 : 1,
                borderColor: checked ? `${color}.main` : 'divider',
                '&:hover': { boxShadow: 2 },
            }}
            onClick={() => onClick({ id, greffes })}
        >
            <CardContent sx={{ paddingTop: 0, paddingBottom: '0px !important' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '0.5em',
                            alignItems: 'flex-start',
                            flexGrow: 1,
                        }}
                    >
                        <Typography
                            variant="l2dh7"
                            fontWeight="500"
                        >
                            {greffes}
                        </Typography>
                    </Box>
                    {checked && (
                        <FaOptionIcon
                            icon={['fasl', 'check']}
                            sx={{ color: `${color}.main` }}
                        />
                    )}
                </Box>
            </CardContent>
        </Card>
    );
};

export default GreffeCard;
